// theme constant
export const gridSpacing = 3;
export const drawerWidth = 56; // App Sidebar width (Figma 8:9989)
export const appDrawerWidth = 320;
